/* PAKKS PAGE RUNTIME (site pages, landing pages, journal, 404, cart). Vanilla; every page works without it.
   1. [data-row] swipe rows: Previous / Next + a track that is keyboard-focusable only while it scrolls (same as the preview's site.js)
   2. Contact: ?topic=<value> preselects the topic (data-topic-alias maps e.g. custom → wholesale)
   3. #anchor on an accordion (/pages/faqs#dropshipper): open it, scroll to it, focus its summary
   4. [data-pk-focus]: a form result / error message takes focus after a submit (screen readers hear it) */
(function () {
  if (window.__pkPageUI) return; window.__pkPageUI = true;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initRow(row) {
    if (row.__pkRow) return; row.__pkRow = true;
    var track = row.querySelector('[data-row-track]'); if (!track) return;
    var list = track.firstElementChild, prev = row.querySelector('[data-row-prev]'), next = row.querySelector('[data-row-next]');
    function stepW() { var c = list.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : track.clientWidth; }
    function sync() {
      var scrollable = track.scrollWidth > track.clientWidth + 2;
      if (scrollable) track.setAttribute('tabindex', '0'); else track.removeAttribute('tabindex');
      row.classList.toggle('is-scrollable', scrollable);
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
    }
    function go(dir) { track.scrollBy({ left: dir * stepW(), behavior: RM ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    addEventListener('resize', sync, { passive: true });
    requestAnimationFrame(sync);
  }
  function init() {
    $$('[data-row]').forEach(initRow);
    var topic = new URLSearchParams(location.search).get('topic'), sel = document.querySelector('select[data-topic]');
    if (topic && sel) {
      (sel.getAttribute('data-topic-alias') || '').split(' ').forEach(function (p) { var kv = p.split(':'); if (kv[0] === topic && !sel.querySelector('option[value="' + topic + '"]')) topic = kv[1]; });
      if (/^[\w-]+$/.test(topic) && sel.querySelector('option[value="' + topic + '"]')) sel.value = topic;
    }
    var f = document.querySelector('[data-pk-focus]'); if (f) { f.scrollIntoView({ block: 'center' }); f.focus({ preventScroll: true }); }
    openHash();
  }
  function openHash() {
    var id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
    var t = id && document.getElementById(id); if (!t) return;
    var d = t.tagName === 'DETAILS' ? t : t.closest('details'); if (!d) return;
    d.open = true; t.scrollIntoView({ block: 'start', behavior: 'auto' });
    var s = d.querySelector('summary'); if (s) s.focus({ preventScroll: true });
  }
  addEventListener('hashchange', openHash);
  addEventListener('load', function () { requestAnimationFrame(openHash); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { $$('[data-row]', e.target).forEach(initRow); });
})();
